export default __webpack_public_path__ + "static/media/prochainevie.2e3ffb13.jpg";